




























































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { namespace } from "vuex-class";

const EventCategorySetup = namespace("eventCategorySetup");

@Component({
	components: {
		"event-categories-tree": () => import("./EventCategoriesTree.vue"),
	},
})
export default class EventCategoriesTree extends Vue {
	@Prop(Object) outcome: any;
	@Prop(String) title: string;
	@Prop(Array) childOutcomes: any[];
	@Prop(Boolean) open: boolean;
	@Prop(Object) node: any;

	@EventCategorySetup.Mutation toggleOutcomeSubTree: any;

	/**
	 * Method to open/close subtree.
	 */
	public openNode() {
		this.toggleOutcomeSubTree(this.node);
		this.nodeOpened(this.node);
	}

	/**
	 * Method to select a event outcome.
	 */
	public selectNode() {
		this.nodeSelected({
			outcome: this.outcome,
			tree: this,
			node: this.node,
		});
	}

	/**
	 * Emit the selected event outcome.
	 */
	@Emit("onSelected")
	public nodeSelected(args: any) {
		return args;
	}

	/**
	 * Emit the event outcome subtrees.
	 */
	@Emit("onOpenNode")
	public nodeOpened(args: any) {
		return args;
	}

	// Used in template to prevent default mousedown behaviour
	private mouseDown() {}
}
